<template>
  <div>
    <!-- Search History list -->
    <div>
      <vs-table id="search-history-list" class="vs-con-loading__container" stripe :sst="true" maxHeight="800px"
        @search="updateSearchQuery" @change-page="handleChangePage" @sort="handleSort" :total="totalSearchHistories"
        :max-items="length" search :data="searchHistories">
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div
                    class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (totalSearchHistories && 1)) || 0 }}
                      -
                      {{ totalSearchHistories - page * length > 0 ? page * length : totalSearchHistories }}
                      of {{ totalSearchHistories || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>

            <div class="flex flex-wrap items-center">
              <vs-pagination v-if="totalSearchHistories" v-model="page" :total="totalPages"
                :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
            <vs-button icon-pack="feather" icon="icon-refresh-ccw" @click="refreshData" class="ml-4"
              size="medium">Refresh</vs-button>
            <vs-button v-if="selectedRows.length" icon-pack="feather" icon="icon-trash" @click="confirmBulkDelete"
              class="ml-4" color="danger" size="medium">Delete Selected ({{ selectedRows.length }})</vs-button>
            <div v-if="search" class="ml-4">
              {{ searchHistories.length || 0 }} results found.
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>
            <div class="flex justify-center w-full">
              <vs-checkbox :value="isAllSelected" :indeterminate="isSomeSelected" @change="toggleSelectAll" />
            </div>
          </vs-th>
          <vs-th>Sr#</vs-th>
          <vs-th sort-key="user">User</vs-th>
          <vs-th sort-key="search_query">Search Query</vs-th>
          <vs-th sort-key="user.handle_name">Handle Name</vs-th>
          <!-- <vs-th sort-key="route_path">Route</vs-th> -->
          <vs-th sort-key="createdAt">Date</vs-th>
          <vs-th>Action</vs-th>
        </template>
        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              <div class="flex justify-center">
                <vs-checkbox :value="selectedRows.includes(tr.id)" @change="toggleRowSelection(tr.id)" />
              </div>
            </vs-td>
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>

            <vs-td>
              <div v-if="tr.user">
                {{ tr.user.first_name }} {{ tr.user.last_name }} <br />
                <small>{{ tr.user.email || tr.user.mobile_number }}</small>
              </div>
              <div v-else>
                Guest/Unknown
              </div>
            </vs-td>
            <vs-td>
              <span>{{ tr.search_query }}</span>
            </vs-td>
            <vs-td>
              <span>{{ tr.user ? tr.user.handle_name : '-' }}</span>
            </vs-td>
            <!-- <vs-td>
                <span>{{ tr.route_path }}</span>
            </vs-td> -->
            <vs-td>
              <span>{{ tr.createdAt ? moment(tr.createdAt).local().format('Do MMMM YYYY, h:mm:ss A') : 'N/A' }}</span>
            </vs-td>
            <vs-td>
              <div class="flex items-center">
                <vx-tooltip text="Delete History">
                  <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer"
                    @click="confirmDelete(tr.id)" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import moment from 'moment'

export default {
  name: 'SearchHistoryList',

  components: {
  },

  data: () => ({
    length: 10,
    page: 1,
    search: '',
    selectedRows: []
  }),

  computed: {
    ...mapState('searchHistory', ['searchHistories', 'totalSearchHistories']),
    totalPages() {
      return Math.ceil(this.totalSearchHistories / this.length)
    },
    isAllSelected() {
      return this.selectedRows.length === this.searchHistories.length && this.searchHistories.length > 0
    },
    isSomeSelected() {
      return this.selectedRows.length > 0 && this.selectedRows.length < this.searchHistories.length
    }
  },

  methods: {
    moment,
    ...mapActions('searchHistory', {
      fetchSearchHistories: 'fetchSearchHistories',
      deleteSearchHistories: 'deleteSearchHistories'
    }),

    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    handleSort(key, active) {
      this.getData({ sortBy: `${key}:${active}` })
    },

    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    async refreshData() {
      try {
        await this.getData()
        this.$vs.notify({
          title: 'Success',
          text: 'Data refreshed successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
      } catch (error) {
        // Error handled in getData
      }
    },

    async getData(params = {}) {
      this.selectedRows = []
      this.$vs.loading({
        container: '#search-history-list',
        scale: 0.6
      })
      const payload = {
        limit: this.length,
        page: this.page,
        ...params
      };
      if (this.search) {
        payload.search_query = this.search;
      }
      try {
        await this.fetchSearchHistories(payload)
      } catch (err) {
        this.$vs.notify({
          color: 'danger',
          title: 'Error',
          text: err.message
        })
      } finally {
        this.$vs.loading.close('#search-history-list > .con-vs-loading')
      }
    },

    confirmDelete(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Delete',
        text: 'Are you sure you want to delete this search history?',
        accept: () => this.deleteHistory(id),
        acceptText: 'Delete'
      })
    },

    async deleteHistory(id) {
      try {
        await this.deleteSearchHistories([id])
        this.$vs.notify({
          title: 'Deleted',
          text: 'Search history deleted successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
        this.getData()
      } catch (err) {
        this.$vs.notify({
          title: 'Error',
          text: err.message || 'Something went wrong',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.selectedRows = []
      } else {
        this.selectedRows = this.searchHistories.map(tr => tr.id)
      }
    },

    toggleRowSelection(id) {
      const index = this.selectedRows.indexOf(id)
      if (index === -1) {
        this.selectedRows.push(id)
      } else {
        this.selectedRows.splice(index, 1)
      }
    },

    confirmBulkDelete() {
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: 'Confirm Bulk Delete',
        text: `Are you sure you want to delete ${this.selectedRows.length} selected records?`,
        accept: () => this.bulkDelete(),
        acceptText: 'Delete'
      })
    },

    async bulkDelete() {
      try {
        await this.deleteSearchHistories(this.selectedRows)
        this.$vs.notify({
          title: 'Deleted',
          text: 'Selected records deleted successfully',
          color: 'success',
          iconPack: 'feather',
          icon: 'icon-check'
        })
        this.selectedRows = []
        this.getData()
      } catch (err) {
        this.$vs.notify({
          title: 'Error',
          text: err.message || 'Something went wrong',
          color: 'danger',
          iconPack: 'feather',
          icon: 'icon-alert-circle'
        })
      }
    }
  },

  watch: {
    page() {
      this.getData()
    }
  },

  mounted() {
    this.getData()
  }
}
</script>
